module.exports = __webpack_public_path__ + "assets/img/examinantion-main-index-back.d5ff10a5.png";